import React, { CSSProperties, ReactElement, ReactNode } from 'react'
import { ThemeProvider } from 'styled-components'
import { theme } from '../../config/theme'
import Button, { ButtonVariant } from '../../general/Button/Button'

export type ButtonProps = {
  type:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'warning'
    | 'danger'
    | 'light'
    | 'information'
  children?: React.ReactNode
  disabled?: boolean
  onChange?: (e: any) => void
  onClick?: () => void
  icon?: ReactNode
  loading?:
    | boolean
    | {
        delay?: number
      }
  isLoading?: boolean
  link?: boolean
  style?: CSSProperties
  buttonInnerStyle?: CSSProperties
  backArrow?: boolean
  noArrow?: boolean
  htmlType?: any
  iconPositionRight?: boolean
  dataTestId?: string
}

const keysToBeDeleted: (keyof React.CSSProperties)[] = [
  'color',
  'backgroundColor',
  'borderColor',
  'padding',
]

const deleteStylingKeys = (
  styling: React.CSSProperties | undefined
): React.CSSProperties => {
  if (!styling) {
    return {}
  }
  const newStyling = { ...styling }
  keysToBeDeleted.forEach((key) => {
    delete newStyling[key]
  })
  delete newStyling.color

  return newStyling
}

const mapTypeToVariant = (type: ButtonProps['type']): ButtonVariant => {
  switch (type) {
    case 'default':
      return 'primary'
    case 'primary':
      return 'primary'
    case 'secondary':
      return 'default'
    case 'warning':
      return 'danger'
    case 'danger':
      return 'danger'
    case 'light':
      return 'default'
    case 'information':
      return 'default'
    default:
      return 'primary'
  }
}

/**
 * @deprecated
 */
export default function ButtonOLD({
  children,
  disabled,
  icon,
  iconPositionRight = false,
  isLoading,
  loading,
  link,
  type,
  style,
  dataTestId,
  ...props
}: ButtonProps): ReactElement {
  return (
    <ThemeProvider theme={theme}>
      <Button
        data-testid={dataTestId}
        data-cy={`btn-${dataTestId}`}
        variant={link ? 'text' : mapTypeToVariant(type)}
        isLoading={!!loading || isLoading}
        disabled={disabled}
        icon={icon as any}
        iconAlign={iconPositionRight ? 'right' : 'left'}
        size="normal"
        style={{
          ...deleteStylingKeys(style),
        }}
        {...props}
      >
        {children}
      </Button>
    </ThemeProvider>
  )
}
